import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import {message} from "antd";
import {FormUtils} from "../../../utils/FormUtils";

const FORM = [
    {
        name: "主机地址",
        key: "host",
        type: "input",
    },
    {
        name: "用户名",
        key: "username",
        type: "input",
    },
    {
        name: "密码",
        key: "password",
        type: "password",
    }
]

const TiandyCameraServerEditPage = () => {
    const [searchParams] = useSearchParams()
    const navigator = useNavigate()

    const guid = searchParams.get("guid")

    const [initFormData, setInitFormData] = useState({})
    const [selectOptions, setSelectOptions] = useState({})

    let changedForms = {}
    let changedFiles = {}

    useEffect(() => {
        if (guid) {
            ApiService.admin.camera.config.get(guid)
                .onSuccess(data => {
                    setInitFormData(data)
                })
        }

        ApiService.constants.religion()
            .onSuccess(data => {
                setSelectOptions({
                    religionId: data.map(item => {
                        return {name: item.name, value: item.guid}
                    })
                })
            })
    }, [guid]);

    const handleFormChange = (change) => {
        changedForms = {
            ...changedForms,
            ...change
        }
    }

    const createOrUpdate = (form) => {
        if (guid) {
            return ApiService.admin.camera.config.update(form)
        } else {
            return ApiService.admin.camera.config.create(form)
        }
    }

    const handleFormSubmit = (event) => {
        try {
            const form = FormUtils.setupSubmitForm(changedForms, changedFiles, true, false, {guid: guid})
            createOrUpdate(form)
                .onSuccess(() => {
                    message.success("数据已保存")
                    navigator(-1)
                })
        } catch (e) {
            message.error(e.message)
            return false
        }
    }

    return (
        <>
            <AutoFormCard
                title={"编辑TD服务器"}
                formStruct={FORM}
                initValues={initFormData}
                selectOptions={selectOptions}
                loading={false}
                onClickCancel={e => {
                    navigator(-1)
                }}
                onClickSubmit={handleFormSubmit}
                onFormChange={handleFormChange}
            />
        </>
    )
}

export default TiandyCameraServerEditPage